"use client";

import { VISIT_LIST_KEY, VISIT_LIST_SWR_CONFIG } from "@repo/sdk";
import { fetchAllCases } from "src/lib/data";
import { CaseListData } from "@repo/provider-network";
import useSWR from "swr";

/**
 * Custom hook for visit list data with SWR
 *
 * SWR Deduplication: SWR automatically deduplicates requests with the same key.
 * When multiple components use this hook:
 * - Only one network request is made (even if components mount simultaneously)
 * - All components share the same cache entry and state (data, isValidating, error)
 * - State changes in one component automatically sync to all other components
 * - Calling mutate() in any component triggers revalidation for all components
 */
export function useVisitList(initialData?: CaseListData, hasTerms = true) {
  return useSWR<CaseListData>(
    hasTerms ? VISIT_LIST_KEY : null,
    fetchAllCases,
    {
      ...VISIT_LIST_SWR_CONFIG,
      fallbackData: initialData,
    }
  );
}
